<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
	                  <zestawieniaMenu></zestawieniaMenu>
        <div class="widget-heading">
          <h3 class="card-header">Lista użytkowników posiadających uprawnienia w ERP</h3>
        </div>

        <div class="widget-content">
          <div class="card-body mt-4">

            <!-- Wyszukiwarka -->
            <div class="row mb-4">
              <div class="col-md-6 col-lg-4">
                <label for="userSearch" class="form-label">
                  Wyszukaj użytkownika
                </label>

                <input id="userSearch" v-model="search" type="text" class="form-control"
                  placeholder="Imię, nazwisko, stanowisko lub login..." @click.stop />
              </div>

              <div class="col-md-6 col-lg-8 d-flex align-items-end mt-2 mt-md-0">
                <span class="text-muted">
                  Liczba użytkowników: {{ filteredUsers.length }}
                </span>

                <button v-if="search" type="button" class="btn btn-outline-secondary ms-3" @click="search = ''">
                  Wyczyść
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover align-middle">
                <thead>
                  <tr>
                    <th style="width: 60px;">Lp.</th>
                    <th>Imię i nazwisko</th>
                    <th>Stanowisko</th>
                    <th>Login</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-for="(user, index) in filteredUsers" :key="user.id">
                    <tr @click="toggleUser(user.id)" style="cursor: pointer;">
                      <td>{{ index + 1 }}</td>

                      <td>
                        <span class="me-2">
                          {{ expandedUserId === user.id ? '▼' : '▶' }}
                        </span>

                        <strong>
                          {{ user.last_name }} {{ user.first_name }}
                        </strong>
                      </td>

                      <td>{{ user.position || '—' }}</td>

                      <td>{{ user.email || user.login || '—' }}</td>
                    </tr>

                    <tr v-if="expandedUserId === user.id">
                      <td colspan="4" class="bg-light">
                        <div class="p-3">
                          <h5 class="mb-3">
                            Uprawnienia użytkownika:
                             {{ user.last_name }} {{ user.first_name }}
                          </h5>

                          <UserPermissions :key="user.id" :user-id="user.id" :is-admin="0"
                            :initial-permissions="user.custom_permissions || {}" />
                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-if="filteredUsers.length === 0">
                    <td colspan="4" class="text-center text-muted py-4">
                      Brak użytkowników pasujących do wyszukiwania.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import UserPermissions from "@/Pages/Admin/Users/UserPermissions.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";

export default {
  components: {
    AppLayout,
    UserPermissions,
	zestawieniaMenu
  },

  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      expandedUserId: null,
      search: "",
    };
  },

  computed: {
    filteredUsers() {
      const query = this.search.trim().toLocaleLowerCase("pl");

      if (!query) {
        return this.users;
      }

      return this.users.filter((user) => {
        const searchableFields = [
          user.first_name,
          user.last_name,
          user.position,
          user.email,
          user.login,
        ];

        const matchesUser = searchableFields.some((field) =>
          String(field ?? "")
            .toLocaleLowerCase("pl")
            .includes(query)
        );

        const permissions = user.custom_permissions || {};

        const matchesPermissions = Object.entries(permissions).some(
          ([name, value]) => {
            const searchablePermission = `${name} ${value}`
              .toLocaleLowerCase("pl");

            return searchablePermission.includes(query);
          }
        );

        return matchesUser || matchesPermissions;
      });
    },
  },

  methods: {
    toggleUser(userId) {
      this.expandedUserId =
        this.expandedUserId === userId ? null : userId;
    },
  },
};
</script>
